<div class="row align-items-center">
	<div class="col-auto pr-0">
		<div class="image-container {{ size }}">
			<img class="rounded-circle" type="user" [src]="src" />
		</div>
	</div>
	<div class="col">
		<div *ngIf="name">{{ name }}</div>
		<div class="text-caption caption" *ngIf="caption">{{ caption }}</div>
	</div>
</div>
